/* ==========================================================================
   Ormonde Jayne — At Home collection page
   Loaded by sections/oj-home-collection.liquid.
   - Keeps --oj-home-top in step with the fixed theme header (which pins and
     unpins on scroll) so the sub-navigation sticks directly beneath it.
   - Highlights the active sub-navigation item and smooth-scrolls in-page anchors.
   - Product shelves: previous / next arrows, and the right-edge fade while
     more cards remain off-screen.
   - Diffuser cards: in-place size picker.
   - Add to bag: POST /cart/add.js, then the theme's cart drawer.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-oj-home]');
  if (!root) return;

  var nav = document.querySelector('nav.main-header-nav');
  var subnav = root.querySelector('[data-oj-home-subnav]');
  var links = subnav ? Array.prototype.slice.call(subnav.querySelectorAll('[data-oj-home-nav]')) : [];
  var topPx = -1;
  var ticking = false;

  /* ---- Header offset + active sub-navigation --------------------------- */
  function headerBottom() {
    if (!nav) return 0;
    var r = nav.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }
  function subnavHeight() { return subnav ? subnav.offsetHeight : 0; }

  function sync() {
    ticking = false;
    var t = headerBottom();
    if (t !== topPx) {
      topPx = t;
      root.style.setProperty('--oj-home-top', t + 'px');
    }
    if (!links.length) return;
    var line = t + subnavHeight() + 24;
    var active = '';
    for (var i = 0; i < links.length; i++) {
      var id = links[i].getAttribute('data-oj-home-nav');
      var el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= line) active = id;
    }
    for (var j = 0; j < links.length; j++) {
      links[j].classList.toggle('is-active', links[j].getAttribute('data-oj-home-nav') === active);
    }
  }
  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  }
  var settleA, settleB;
  function onScroll() {
    request();
    /* the header pins/unpins with a 0.2s transform transition after the scroll event: settle twice */
    clearTimeout(settleA); clearTimeout(settleB);
    settleA = setTimeout(sync, 260);
    settleB = setTimeout(sync, 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', request);
  if (nav) nav.addEventListener('transitionend', request);
  sync();
  setTimeout(sync, 300);
  setTimeout(sync, 1200);

  /* ---- In-page anchors ------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || !root.contains(a)) return;
    var id = a.getAttribute('href').slice(1);
    var el = id ? document.getElementById(id) : null;
    if (!el) return;
    e.preventDefault();
    var rect = el.getBoundingClientRect();
    var goingDown = rect.top > 0;
    /* the theme header hides while scrolling down and returns while scrolling up */
    var headerPart = goingDown ? 0 : (nav ? nav.offsetHeight : 0);
    var belowSubnav = subnav ? !!(subnav.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) : false;
    var offset = headerPart + (belowSubnav ? subnavHeight() : 0) + 16;
    var top = window.pageYOffset + rect.top - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    if (window.history && window.history.replaceState) {
      try { window.history.replaceState(null, '', '#' + id); } catch (err) { /* ignore */ }
    }
  });

  /* ---- Shelves: arrows + edge fade ------------------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-oj-home-shelf]'), function (shelf) {
    var rail = shelf.querySelector('[data-oj-home-rail]');
    if (!rail) return;
    var wrap = rail.parentNode;
    var frame = 0;

    function measure() {
      frame = 0;
      wrap.classList.toggle('has-more', rail.scrollWidth - rail.clientWidth - rail.scrollLeft > 4);
    }
    function queue() {
      if (frame) return;
      frame = window.requestAnimationFrame(measure);
    }
    function step() { return Math.max(240, rail.clientWidth * 0.7); }

    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    var prev = shelf.querySelector('[data-oj-home-prev]');
    var next = shelf.querySelector('[data-oj-home-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    measure();
    setTimeout(measure, 400);
    window.addEventListener('load', measure);
  });

  /* ---- Size picker ----------------------------------------------------- */
  function closePickers(except) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-oj-home-sizes]'), function (panel) {
      if (panel === except) return;
      var card = panel.closest('[data-oj-home-card]');
      var btn = card ? card.querySelector('[data-oj-home-choose]') : null;
      panel.hidden = true;
      if (btn) { btn.hidden = false; btn.setAttribute('aria-expanded', 'false'); }
    });
  }
  root.addEventListener('click', function (e) {
    var choose = e.target.closest('[data-oj-home-choose]');
    if (choose) {
      e.preventDefault();
      var card = choose.closest('[data-oj-home-card]');
      var panel = card ? card.querySelector('[data-oj-home-sizes]') : null;
      if (!panel) return;
      closePickers(panel);
      panel.hidden = false;
      choose.hidden = true;
      choose.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('button:not([disabled])');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    var close = e.target.closest('[data-oj-home-sizes-close]');
    if (close) {
      e.preventDefault();
      var panel2 = close.closest('[data-oj-home-sizes]');
      var card2 = close.closest('[data-oj-home-card]');
      var btn2 = card2 ? card2.querySelector('[data-oj-home-choose]') : null;
      if (panel2) panel2.hidden = true;
      if (btn2) { btn2.hidden = false; btn2.setAttribute('aria-expanded', 'false'); btn2.focus({ preventScroll: true }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePickers();
  });

  /* ---- Add to bag ------------------------------------------------------ */
  function setLabel(btn, text) {
    var span = btn.querySelector('span');
    if (span) span.textContent = text; else btn.textContent = text;
  }
  function openCartDrawer() {
    try {
      if (window.cart_popup && typeof window.cart_popup.updateCartPopup === 'function' && window.jQuery) {
        window.cart_popup.updateCartPopup(function () {
          window.jQuery('.cart-popup-wrapper').addClass('open');
          window.jQuery('html').removeClass('cart-popup-wrapper-open').addClass('cart-popup-wrapper-open');
        });
      }
    } catch (err) { /* cart drawer unavailable */ }
  }
  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-oj-home-add'), 10);
    if (!id || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.getAttribute('data-label') || '';
    var added = btn.getAttribute('data-label-added') || label;
    var isSize = btn.hasAttribute('data-oj-home-size');
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || (r.data && r.data.status)) {
          throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to bag');
        }
        if (isSize) {
          closePickers();
        } else {
          setLabel(btn, added);
          clearTimeout(btn._ojT);
          btn._ojT = setTimeout(function () { setLabel(btn, label); }, 1800);
        }
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('oj-home:added', { detail: { variantId: id } }));
      })
      .catch(function (err) {
        setLabel(btn, (err && err.message) || 'Could not add to bag');
        clearTimeout(btn._ojT);
        btn._ojT = setTimeout(function () { setLabel(btn, label); }, 2500);
      })
      .then(function () { btn.setAttribute('aria-busy', 'false'); });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oj-home-add]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    addToCart(btn);
  });
})();
